const results = [
  {
    icon: 'ri-user-star-line',
    audience: 'Эксперты',
    img: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/02fdba16038956dbef33557d60eba2f8.jpeg',
    metrics: [
      { value: '80%', label: 'Экономия времени на записи контента для воронки продаж' },
      { value: '+18%', label: 'Рост конверсии в просмотр видео-контента' },
    ],
  },
  {
    icon: 'ri-store-2-line',
    audience: 'Интернет-магазины. Товары',
    img: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/df78b7367a30f9af33c0228b56d96931.png',
    metrics: [
      { value: '+20%', label: 'Увеличение продаж благодаря видео-объяснению преимуществ продукта' },
      { value: 'x2', label: 'Рост времени пребывания на странице товара' },
    ],
  },
];

export default function AIAvatarResults() {
  return (
    <section className="py-14 sm:py-28 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-bar-chart-2-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Кейсы и цифры
            </span>
          </div>
          <h2 className="text-xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Твёрдые результаты
          </h2>
          <p className="text-gray-600 font-['Montserrat'] text-sm sm:text-base max-w-xl mx-auto leading-relaxed text-center">
            Покажем на примерах, как это работает:
          </p>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-8">
          {results.map((r) => (
            <div key={r.audience} className="bg-white rounded-2xl overflow-hidden border border-[#E8DDD0] hover:border-[#C5A880] transition-colors duration-300">
              <div className="w-full overflow-hidden bg-white">
                <img
                  src={r.img}
                  alt={r.audience}
                  className="w-full h-auto object-contain"
                />
              </div>
              <div className="p-5 sm:p-8">
                <div className="flex items-center gap-3 mb-4 sm:mb-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#1A2B4C] flex-shrink-0">
                    <i className={`${r.icon} text-lg text-[#C5A880]`}></i>
                  </div>
                  <h3 className="text-sm sm:text-lg font-bold text-[#1A2B4C] font-['Playfair_Display'] leading-snug">
                    {r.audience}
                  </h3>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                  {r.metrics.map((m) => (
                    <div key={m.label} className="bg-[#F9F5EF] rounded-xl p-4 border border-[#E8DDD0]">
                      <div className="text-2xl sm:text-3xl font-bold text-[#C5A880] font-['Playfair_Display'] mb-1 text-center">
                        {m.value}
                      </div>
                      <p className="text-gray-600 text-xs leading-relaxed font-['Montserrat'] text-center">
                        {m.label}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
